// extracted by mini-css-extract-plugin
export default {"container":"xc_kMR","responsive":"MVzrYf"};